import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ObjectBaseComponent} from "../../../../../core/shared/object/mvs-object-base/object-base.component";
import {NavigationItem} from "../../../../../core/shared/dto/navigation/navigation-item";
import {EaProjectDto} from "../../../model/dto/entity/ea-project.dto";


@Component({
    selector: 'ea-project-object-component',
    templateUrl: 'ea-project-object.component.html',
    standalone: false
})
export class EaProjectObjectComponent extends ObjectBaseComponent implements OnInit, OnChanges, OnDestroy {

    navigationItems: NavigationItem[] = [
        {
            label: 'Overview',
            action: 'overview',
            icon: 'fa-regular fa-house text-xl',
            tooltip: 'Project Overview',
            toggleable: false,
            default: true
        },
        {
            label: 'Source Files',
            action: 'sourceFiles',
            icon: 'fa-regular fa-file-alt text-xl',
            tooltip: 'Source Files',
            toggleable: false,
            default: false
        },
        {
            label: 'Analysis Results',
            action: 'analysisResults',
            icon: 'fa-regular fa-chart-bar text-xl',
            tooltip: 'Analysis Results',
            toggleable: false,
            default: false
        },
        {
            label: 'Model Drafts',
            action: 'modelDrafts',
            icon: 'fa-regular fa-sitemap text-xl',
            tooltip: 'Model Drafts',
            toggleable: false,
            default: false
        },
        {
            label: 'Import Configs',
            action: 'importConfigs',
            icon: 'fa-regular fa-upload text-xl',
            tooltip: 'Import Configurations',
            toggleable: false,
            default: false
        }
    ];

    activeNavigationItem: NavigationItem;

    get projectDto(): EaProjectDto {
        return this.dto as EaProjectDto;
    }

    ngOnInit() {
        super.ngOnInit();
        this.activeNavigationItem = this.navigationItems.find(item => item.default);
    }

    onObjectChanged() {
        if (this.dto?.name) {
            this.setPageTitle(`${this.dto.name} - EA Project`);
        }
    }

    onNavigationItemChange(navigationItem: NavigationItem) {
        this.activeNavigationItem = navigationItem;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (!this.initialized) {
            return;
        }
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
